import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import {FiX} from '../../assets/icons/vander'

export default function Modal() {
    let [show, setShow] = useState(false)
  return (
        <div className="col-md-9 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="ms-md-4">
                <Link to="#" className="btn btn-primary" onClick={()=>setShow(!show)}> Click Here</Link>
            </div>

            <div className={`modal fade ${show ? 'show d-block' : ''}`} style={{backgroundColor:'#00000099'}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content rounded shadow border-0">
                        <div className="modal-header">
                            <h5 className="modal-title">Modal title </h5>
                            <button type="button" className="btn btn-icon btn-close" onClick={()=>setShow(!show)}><FiX className="fs-4 text-dark"/></button>
                        </div>
                        <div className="modal-body">
                            <div className="bg-white p-3 rounded box-shadow">
                                <p className="text-muted mb-0">Dummy text is also used to demonstrate the
                                    appearance of different typefaces and layouts, and in general the
                                    content of dummy text is nonsensical. Due to its widespread use as
                                    filler text for layouts, non-readability is of great importance:
                                    human perception is tuned to recognize certain patterns and
                                    repetitions in texts. If the distribution of letters and 'words' is
                                    random, the reader will not be distracted from making a neutral
                                    judgement on the visual impact and readability of the typefaces
                                    (typography), or the distribution of text on the page (layout or
                                    type area). For this reason, dummy text usually consists of a more
                                    or less random series of words or syllables. This prevents
                                    repetitive patterns from impairing the overall visual impression and
                                    facilitates the comparison of different typefaces. Furthermore, it
                                    is advantageous when the dummy text is relatively realistic so that
                                    the layout impression of the final publication is not compromised.
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary">Close</button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}
